<template>
  <b-modal ref="modalImportFichesTEchniques" scrollable size="lg" title="Importer des fiches Techniques"
      ok-title="Fermer"
      :ok-only=true
      :ok-disabled="!resultatImportFichier"
      no-close-on-backdrop
      @show="initialiserModale()"
      @ok="fermerImport()">
      <template slot="default">
        <div style="display: inline">
          <div class="container-fluid card card-body">
            <div class="row importFichier">
              <div class="col-2">
                <button class="btn btn-primary" @click="$refs.importFicheTechnique.click()">Choisir Fichier</button>
                <input type="file" accept=".pdf,.zip" @change="choisirFichesTechniques($event)" style="display: none" ref="importFicheTechnique" />
              </div>
              <div class="col-8 importFichier">
                <label>{{ nomDuFichier }}</label>
              </div>
              <div class="col-2 aligner-droite">
                <button class="btn btn-success" @click="importerFichesTechniques()">Importer</button>
              </div>
            </div>
          </div>

          <div v-if="!resultatImportFichier && fichierEnCours" class="container-fluid card card-body">
            <div class="row">
              <div class="col-12 form-group">
                <i class="fas fa-spinner fa-spin mr-2"></i>{{ etatImportFichier }}
              </div>  
            </div>
          </div>

          <div v-if="resultatImportFichier"> <!--On affiche une ligne par fichier avec le résultat général-->
            <div class="container-fluid card card-body accordion collapse-icon accordion-icon-rotate">
              <template v-for="(resultat, iResultat) in resultatImportFichier">
                
                <div class="row" :key="'result-'+iResultat" :id="'nomFichier-'+iResultat" data-toggle="collapse" :href="'#detailErreur-'+iResultat">
                  <div class="col-12 form-group">
                    <i :class="[{'fas fa-exclamation-circle text-error mr-2':resultat && !resultat.fichierValide},
                                {'fas fa-check-circle text-success mr-2':resultat && resultat.fichierValide && !resultat.listeErreurs.some(x => x.warning)},
                                {'fas fa-exclamation-circle text-warning mr-2':resultat && resultat.fichierValide && resultat.listeErreurs.some(x => x.warning)}]"></i>
                    <span>{{ resultat.etatImportFichier }}</span>
                    <span v-if="!resultat.fichierValide || (resultat.fichierValide && resultat.listeErreurs.some(e => e.warning))"> : {{ resultat.listeErreurs.first().erreur }}</span>
                  </div>
                </div>

                <!--<div v-if="!resultat.fichierValide || (resultat.fichierValide && resultat.listeErreurs.some(e => e.warning) )" :id="'detailErreur-'+iResultat" :aria-labelledby="'detailErreur-'+iResultat" class="row collapse" :key="'resultErreur-'+iResultat">
                  <div class="col-12 form-group">
                    <table class="table table-bordered table-sm text-center">
                      <colgroup>
                        <col width="200">
                        <col>
                      </colgroup>
                      <thead class="table-header-secondary">
                        <th>Désignation Produit</th>
                        <th>Message d'erreur</th>
                      </thead>
                      <tbody>
                        <template v-for="(msg, iMsg) in resultat.listeErreurs">
                          <tr class="separateur" :key="'msg-'+iMsg">
                            <td class="aligner-gauche">
                              {{ msg.designationAgap }}
                            </td>
                            <td class="aligner-gauche">
                              {{ msg.erreur }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>-->
              </template>
            </div>
          </div>

          <div v-if="resultatImportFichier && resultatImportFichier.some(x => x.fichierValide)" class="container-fluid card card-body">
            <div class="row">
              <div class="col-12 form-group">
                <em>
                  <p>
                    Merci de vérifier vos propositions avant de les envoyer
                  </p>
                </em>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
</template>

<script>

import { importerFichesTechniques } from '@/api/gpao/propositions'
import { connecteData } from "@/mixins/connecteData"
import { arrondiMercuriale } from '../helpers/utils'
import { showAlerts } from "@/mixins/alerts"

export default {
  name: "ModalImportFichesTechniques",
  props: {
    datePropoId: {type: Number},
    familleId: {type: Number},
    propoArticleId: {type: Number},
  },
  mixins: [ connecteData, showAlerts],
  data() {
    return {
      resultatImportFichier: null,
      etatImportFichier: "",
      fichierEnCours: false,
      formData: null,
      selectedFile: null,
    }
  },
  watch: {
    
  },
  computed: {
    contenuDuFichier() {
      return this.formData ?? new FormData()
    },
    nomDuFichier() {
      return this.selectedFile?.name ?? ""
    },
  },
  methods: {

    initialiserModale() {
      //on affiche la modale de suivi du chargement avec l'etat initial
      this.etatImportFichier = "Controle et chargement du fichier en cours ..."
      //this.resultatImportFichier = null
    },
    messageFichier(resultat) {
      return resultat.etatImportFichier + (((resultat && !resultat.fichierValide) || (resultat && resultat.fichierValide && resultat.listeErreurs.some(x => x.warning))) ? "  <u>(voir détail)</u>" : "" )  
    },
    choisirFichesTechniques(event) {
      //on récupère le fichier à traiter
      this.fichierEnCours = false
      if (event.target.files.length != 0) {
        this.formData = new FormData();
        this.selectedFile = event.target.files[0];

        if (this.selectedFile.size > (1024 * 1024 * 100)) {
          // Fichier de 100 Mo maximum
          this.alerteErreur("Le fichier que vous tentez d'importer est trop volumineux (" + arrondiMercuriale(this.selectedFile.size / 1024 / 1024) + " Mo). Taille maximale : 100 Mo.")
          return
        }

        this.formData.append('fichier', this.selectedFile);
      }
    },
    async importerFichesTechniques() {
      this.fichierEnCours = true
      this.resultatImportFichier = null
      //on appel l'API de chargement des fiches techniques et on affiche le résultat dans la modale, via la variable resultatImportFichier
      let resp = await importerFichesTechniques(this.fournisseurCourantId, this.datePropoId, this.familleId, this.contenuDuFichier)
      this.resultatImportFichier = resp.data
     
      //this.$emit("rechargerPropo")
    },
    fermerImport() {
      this.$emit("rechargerPropo")
      this.hide()  
    },
    show() {
      this.$refs.modalImportFichesTEchniques.show()
    },
    hide() {
      this.$refs.modalImportFichesTEchniques.hide()
    }
  }
}
</script>